// NB: this file is a placeholder; the actual module/RegExp are generated during the container build process
// The actual file will only exist inside the container; this is here simply to prevent linting errors/IDE warnings

// eslint-disable-next-line import/no-default-export
export default /\w/; // Will match any word character (placeholder for actual RegExp)
